export const COMMISSION_SOURCE_TABS = [
  { label: "FC Motivate", value: "fc_motivate" },
  { label: "Email Manager", value: "email_manager" },
  { label: "ACE Performance", value: "ace_performance" },
  { label: "Sales Team", value: "sales_team" },
];
